import { useEffect } from 'react';
import { useNavigate, useLocation, useParams, Outlet } from 'react-router';
import routes from '@commons/routes';
import { useUser } from '@contexts/UserContext';
import { EmptyStatePage } from '@components/EmptyStatePage';
import { IconLock } from '@tabler/icons-react';
import { useIntl } from 'react-intl';

export const RequireUser = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const params = useParams();
  const { user, logoutWithCallback } = useUser();
  const intl = useIntl();

  useEffect(() => {
    if (
      params.username &&
      user?.username &&
      params.username !== user.username
    ) {
      logoutWithCallback(() => {
        navigate(routes.routes.userLogin);
      });
    }
  }, [user, params.username, navigate, location.pathname]);

  if (
    params.username &&
    !user?.username &&
    params.username !== user?.username
  ) {
    return (
      <EmptyStatePage
        icon={<IconLock size={120} stroke={1} />}
        heading={intl.formatMessage({ id: 'error403' })}
        content={intl.formatMessage({ id: 'error403Content' })}
      />
    );
  }

  return <Outlet />;
};
